// extracted by mini-css-extract-plugin
module.exports = {"vBlue":"#107ef1","ListItem":"InnerListItem__ListItem___EdBFf","inner":"InnerListItem__inner___Brss8","icon":"InnerListItem__icon___gDW91"};